export const ACTION_TYPES = {
  TOGGLE_SHOW_USER_MENU: "navBar/TOGGLE_SHOW_USER_MENU",
  SET_SHOW_NAVBAR: "navBar/SET_SHOW_NAVBAR"
};

export const toggleShowUserMenu = () => ({
  type: ACTION_TYPES.TOGGLE_SHOW_USER_MENU
});

export const setShowNavBar = (showNavBar) => ({
  type: ACTION_TYPES.SET_SHOW_NAVBAR,
  payload: { showNavBar }
});
